import MetaBaseDashBoardFive from "../../features/MetabaseDashBoard/MetaBaseDashBoardFive"

const MetabaseReport4 = () => {
  return (
    <div><MetaBaseDashBoardFive/></div>
  )
}

export default MetabaseReport4